import { ReactElement } from "react"

import CreateAcuDeviceForm from "../../../../components/devices/lct/acu/createAcuDeviceForm"
import NewAcuDeviceVersionProvider from "../../../../components/devices/lct/acu/providers/newAcuDeviceVersionProvider"

const NewAcuDeviceVersion = (): ReactElement => (
    <NewAcuDeviceVersionProvider>
        <CreateAcuDeviceForm />
    </NewAcuDeviceVersionProvider>
)

export default NewAcuDeviceVersion
